import React from 'react'
import { useBetContext } from '../context/BetContext'

//import { ArrowUpRight, ArrowDownRight } from 'lucide-react';

interface TotalOddsDisplayProps {
  current: number;
  previous?: number;
  flash?: boolean;
  showArrow?: boolean;
  acceptOddsChange?:boolean
}

// as far as i can tell, there's no logic to keep track of previous total odds
// could be backend?
const TotalOddsDisplay: React.FC<TotalOddsDisplayProps> = ({
  current,
  previous = -1,
  flash = true,
  showArrow = true,
  acceptOddsChange 
}) => {
  const hasChanged:boolean = previous !== undefined && previous !== current
  const wentUp:boolean = previous !== undefined && current > previous
  const wentDown:boolean = previous !== undefined && current < previous
  
  const { config } = useBetContext()
  
  const { calculationResultBottom } = config
  
  const downArrow = 'duration-300 animate-pulse absolute bottom-0 right-0 w-0 h-0 border-l-[8px] border-l-transparent border-b-[8px] border-b-red-600'
  const upArrow = 'duration-300 animate-pulse absolute top-0 right-0 w-0 h-0 border-l-[8px] border-l-transparent border-t-[8px] border-t-green-500'
  
  return calculationResultBottom ?
    <span className='my-bets-price-box font-bold absolute right-[10px] bottom-[10px] border border-solid border-[var(--border)] px-[6px] font-bold bg-[var(--card)]'>{current}</span>
    : (
      <div className='bet-builder-price-box inline-block text-center mr-[6px] ml-[4px]'>
        <span className={`bet-builder-price relative border border-solid border-[var(--border)] px-[6px] font-bold bg-[var(--card)]`}>
          {current}
          <span className={wentDown ? downArrow : wentUp ? upArrow : "hidden"} />
        </span>
        {hasChanged && acceptOddsChange && (
          <div className='line-through'>
            {previous>-1?previous:''}
          </div>
        )}
      </div>
    )
}

export default TotalOddsDisplay
